export default "__VITE_ASSET__BMss4rGY__"